// Native details keeps the menu usable before JavaScript loads.
function initializeAdagioMenu() {
  const menu = document.querySelector('[data-adagio-menu]');
  if (!menu || menu.dataset.initialized) return;

  menu.dataset.initialized = 'true';
  const toggle = menu.querySelector('summary');

  const close = (restoreFocus = false) => {
    if (!menu.open) return;
    menu.open = false;
    if (restoreFocus) toggle.focus();
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) {
      event.preventDefault();
      close(true);
    }
  });
  menu.addEventListener('click', (event) => {
    if (event.target.closest('a')) close();
  });
  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target)) close();
  });
  window.addEventListener('resize', () => close());
}

initializeAdagioMenu();
document.addEventListener('shopify:section:load', initializeAdagioMenu);
